import {
  AvailableSupplierRequest,
  SupplierLookupApiService,
  SupplierLookupModel,
} from '@abb-procure/data';
import { BooleanInput } from '@angular/cdk/coercion';
import { ScrollingModule } from '@angular/cdk/scrolling';
import {
  Component,
  booleanAttribute,
  effect,
  inject,
  input,
  signal,
} from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { FilterButton } from '../filter-button/filter-button.component';
import { FilterItem } from '../filter-item/filter-item.component';

@Component({
  selector: 'procure-filter-suppliers',
  templateUrl: './filter-suppliers.component.html',
  imports: [ReactiveFormsModule, ScrollingModule, FilterButton],
  providers: [{ provide: FilterItem, useExisting: FilterSuppliers }],
})
export class FilterSuppliers extends FilterItem {
  readonly control = input.required<FormControl<SupplierLookupModel[]>>();

  readonly infiniteScroll = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  readonly tooltip = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  readonly primary = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  readonly items = signal<SupplierLookupModel[]>([]);
  readonly searchTerm = signal<string | null>(null);
  readonly isLoading = signal(false);
  readonly loading = signal(false);

  private readonly supplierApiService = inject(SupplierLookupApiService);
  private pageSize = 20;
  private pageIndex = 1;

  constructor() {
    super();

    effect(() => {
      this.isLoading.set(this.loading());
    });
  }

  protected async fetch(searchTerm: string): Promise<void> {
    if (searchTerm === this.searchTerm()) {
      this.pageIndex++;
    } else {
      this.pageIndex = 1;
      this.items.set([]);
    }

    this.searchTerm.set(searchTerm);

    const startRow = (this.pageIndex - 1) * this.pageSize;

    const request: AvailableSupplierRequest = {
      startRow,
      endRow: startRow + this.pageSize,
      sortAscending: true,
      localDivisionIds: [],
      searchTerm: searchTerm || null,
      mDFs: [],
    };

    this.loading.set(true);

    const result = await this.supplierApiService.getSuppliersBase(request);

    this.loading.set(false);

    this.items.update((values) => [...values, ...(result?.items ?? [])]);
  }
}
